import React from "react";
import { Button } from "./ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardFooter } from "./ui/card";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import EventPopup from "./EventPopup";

const Landing = () => {
  const navigate = useNavigate();

  const ticketTypes = [
    { name: "I. kategória", price: "árak hamarosan" },
    { name: "II. kategória", price: "árak hamarosan" },
    { name: "III. kategória", price: "árak hamarosan" },
    { name: "IV. kategória", price: "árak hamarosan" }
  ];

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <div className="min-h-screen bg-black text-white font-serif selection:bg-[#d4af37] selection:text-black">
      <EventPopup />
      {/* ide raktam a navbar-t reméllem nem csúszik el mobilon */}
      <nav className="flex justify-between items-center px-6 md:px-12 py-6 md:py-8 border-b border-white/10 backdrop-blur-md sticky top-0 z-50 bg-black/50">
        <h1 className="text-xl md:text-2xl font-bold tracking-[0.2em] md:tracking-[0.3em] uppercase text-[#d4af37]">Budapesti Jogászbál</h1>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 items-center uppercase text-xs tracking-widest font-sans font-bold">
           <a href="https://www.budapestijogaszbal.com/" className="hover:text-[#d4af37] transition-colors">Az Eseményről</a>
           <Button variant="outline" className="border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-black border-2" onClick={() => navigate("/admin")}>Belépés</Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden text-[#d4af37] p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-black/95 border-b border-white/10 flex flex-col items-center py-8 gap-6 md:hidden animate-fade-in">
             <a href="https://www.budapestijogaszbal.com/" onClick={() => setIsMenuOpen(false)} className="text-[#d4af37] uppercase tracking-widest text-sm font-bold">Az Eseményről</a>
             <Button 
               variant="outline" 
               className="border-[#d4af37] text-[#d4af37] w-2/3 py-6 text-sm font-bold" 
               onClick={() => { setIsMenuOpen(false); navigate("/admin"); }}
             >
               Belépés
             </Button>
          </div>
        )}
      </nav>

      {/* ezek a jegyek, az árát most fehérre raktam ahogy kértétek */}
      <section id="tickets" className="py-20 px-12 bg-[#050505] min-h-[70vh] flex flex-col justify-center">
          <div className="text-center mb-16">
              <h4 className="text-[#d4af37] uppercase tracking-[0.3em] font-sans font-bold mb-4 animate-fade-in-up">Hol szeretne helyet foglalni?</h4>
              <h2 className="text-4xl md:text-6xl font-black animate-fade-in-up" style={{ animationDelay: '0.2s' }}>Kategóriák</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-[90rem] mx-auto">
              {ticketTypes.map((t, i) => (
                  <Card key={i} className="bg-black/40 border-white/5 hover:border-[#d4af37]/30 transition-all duration-500 group overflow-hidden relative backdrop-blur-sm">
                      {/* Dekorációs sarok elem */}
                      <div className="absolute top-0 right-0 p-3 opacity-20 group-hover:opacity-100 transition-opacity duration-700">
                          <div className="w-8 h-8 border-t border-r border-[#d4af37]"></div>
                      </div>
                      
                      <CardHeader className="pt-10 text-center pb-2">
                          <div className="text-[#d4af37]/40 text-[10px] uppercase tracking-[0.3em] mb-2 font-sans group-hover:text-[#d4af37]/80 transition-colors">Választható</div>
                          <CardTitle className="text-xl font-bold tracking-[0.15em] text-[#d4af37] uppercase font-serif">{t.name}</CardTitle>
                      </CardHeader>
                      
                      <CardContent className="text-center py-6">
                          <div className="text-xl font-light font-sans text-white/90 group-hover:text-white transition-colors">{t.price}</div>
                          <div className="text-[10px] text-white/20 uppercase tracking-widest mt-1">/ fő</div>
                      </CardContent>
                      
                      <CardFooter className="pb-10 justify-center px-8">
                          <Button 
                            disabled
                            className="w-full bg-transparent border border-white/10 text-gray-600 font-bold uppercase text-[10px] tracking-[0.2em] py-6 rounded-none cursor-not-allowed"
                          >
                            Regisztráció hamarosan
                          </Button>
                      </CardFooter>
                      
                      {/* Háttér fényeffekt */}
                      <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#d4af37]/5 rounded-full blur-3xl group-hover:bg-[#d4af37]/10 transition-all duration-700"></div>
                  </Card>
              ))}
          </div>
      </section>

      {/* FOOTER */}
      <footer className="py-20 border-t border-white/10 text-center px-12">
        <div className="mb-8 space-y-4">
            <p className="font-sans text-xs uppercase tracking-[0.4em] text-gray-500 mb-2">Budapesti Jogászbál 2027</p>
            <div className="flex justify-center gap-6 mt-6">
                <a href="/adatvedelem" className="text-[#d4af37] text-xs uppercase tracking-widest hover:text-white transition-colors border-b border-[#d4af37]/20 pb-1">Adatvédelmi Szabályzat</a>
            </div>
        </div>

        <div className="w-full py-4 mt-12 sm:mt-24 border-t border-white/5 flex justify-center items-center">
          <div className="flex items-center gap-2">
            <span className="text-white/50 font-['Arial',sans-serif] text-[12px] mr-1">made with love by:</span>
            <a href="https://www.devhound.hu/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <span className="text-white/90 font-['Arial',sans-serif] font-medium text-[14px]">Bowman and Becker</span>
              <div className="w-px h-4 bg-white/20 mx-1"></div>
              <div className="bg-[#111111] border border-white/5 px-2.5 py-1 rounded flex items-center justify-center">
                <span className="text-[#22C55E] font-mono text-[12px] font-bold tracking-wide">&lt;/CODE&gt;</span>
              </div>
            </a>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes subtle-zoom {
          from { transform: scale(1.1); }
          to { transform: scale(1.2); }
        }
        .animate-subtle-zoom {
           animation: subtle-zoom 20s linear infinite alternate;
        }
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
           animation: fade-in-up 1.5s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Landing;
